import script from "./Billing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Billing.vue?vue&type=script&setup=true&lang=ts"

import "./Billing.vue?vue&type=style&index=0&id=add4e320&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add4e320"]])

export default __exports__